module.exports = __webpack_public_path__ + "img/icon-ai-magic-wand.bd01bb7b.svg";